(function () {
  'use strict';
  const root = document.querySelector('.kp-page');
  if (!root) return;

  const cutoffHour = 14;
  const parisNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    return Object.fromEntries(parts.map(part => [part.type, Number(part.value)]));
  };
  const duration = seconds => {
    const h = Math.floor(seconds / 3600), m = Math.floor(seconds % 3600 / 60), s = seconds % 60;
    return `${h} h ${String(m).padStart(2, '0')} min ${String(s).padStart(2, '0')} s`;
  };
  const setShippingDates = () => {
    const parts = parisNow();
    const today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
    const tomorrow = new Date(today.getTime() + 86400000);
    const format = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', day: 'numeric', month: 'long' });
    root.querySelectorAll('[data-reference-date="0"]').forEach(el => { el.textContent = format.format(today); });
    root.querySelectorAll('[data-reference-date="1"]').forEach(el => { el.textContent = format.format(tomorrow); });
  };
  window.kpShippingClock = function () {
    let previousDay = null;
    const render = () => {
      const n = parisNow();
      const elapsed = n.hour * 3600 + n.minute * 60 + n.second;
      const today = elapsed < cutoffHour * 3600;
      const remaining = (today ? cutoffHour * 3600 - elapsed : 24 * 3600 + cutoffHour * 3600 - elapsed);
      if (previousDay !== n.day) setShippingDates();
      previousDay = n.day;
      root.querySelectorAll('.shipping__message--today').forEach(el => { if (el.style.display !== (today ? 'block' : 'none')) el.style.display = today ? 'block' : 'none'; });
      root.querySelectorAll('.shipping__message--tomorrow').forEach(el => { if (el.style.display !== (today ? 'none' : 'block')) el.style.display = today ? 'none' : 'block'; });
      root.querySelectorAll(today ? '.remain-time' : '.within-time').forEach(el => { el.textContent = duration(remaining); });
      root.classList.add('kp-shipping-ready');
    };
    render(); setInterval(render, 1000);
  };
  window.kpShippingClock();

  const variant = Number(root.querySelector('[data-kp-product]')?.dataset.kpProduct || 0);
  let adding = false;
  root.querySelectorAll('[data-kp-atc]').forEach(button => button.addEventListener('click', async event => {
    event.preventDefault(); event.stopImmediatePropagation();
    if (adding) return;
    const card = button.closest('.package');
    const quantity = Number(card.dataset.kpQuantity);
    if (!variant || ![1, 2, 4].includes(quantity)) return;
    adding = true; button.setAttribute('aria-busy', 'true');
    const label = button.innerHTML;
    button.textContent = 'Ajout en cours…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id:variant,quantity,properties:{Offre:card.querySelector('.pkage_heading').textContent.trim()}}]})
      });
      if (!response.ok) throw new Error('Impossible d’ajouter l’offre. Réessayez.');
      location.assign('/checkout');
    } catch (error) {
      let status = card.querySelector('.kp-atc-status');
      if (!status) {
        status = document.createElement('p'); status.className = 'kp-atc-status'; status.setAttribute('role','status');
        button.after(status);
      }
      status.textContent = error.message;
      button.innerHTML = label; button.removeAttribute('aria-busy'); adding = false;
    }
  }, true));
})();
